import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/home-page';
import Contacts from './pages/contacts-page';
import Fixed from './pages/products-fixed-page';
import Implants from './pages/products-implants-page';
import Removable from './pages/products-removable-page';
import AboutUsMission from './pages/aboutus-mission-page';
import AboutUsDentistry from './pages/aboutus-dentistry-page';

// Fixed Products Detail Pages
import BruxZir from './pages/fixed/bruxzir-page';
import FullCast from './pages/fixed/fullcast-page';
import Zirconia from './pages/fixed/zirconia-page';
import PFM from './pages/fixed/pfm-page';
import Emax from './pages/fixed/emax-page';
import PMMA from './pages/fixed/pmma-page';
import Zirlux from './pages/fixed/zirlux-page';

// Removable Products Detail Pages
import CastPartial from './pages/removable/castpartial-page';
import CompleteDenture from './pages/removable/complete-page';
import EconomyAcrylicPartial from './pages/removable/economyacrylicpartial-page';
import EconomyDenture from './pages/removable/economydenture-page';
import ValplastCastComboPartial from './pages/removable/valplastcastcombopartial-page';
import ValplastFlexiblePartial from './pages/removable/valplastflexiblepartial-page';

// Implant Products Detail Pages
import FCZScrewRetainedHybridCrown from './pages/implants/fczscrewretainedhybridcrown-page';
import TitaniumAbutment from './pages/implants/titaniumabutment-page';
import ZirconiaAbutment from './pages/implants/zirconiaabutment-page';
import ZirconiaHybridImplantBridge from './pages/implants/zirconiahybridimplantbridge-page';

import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/products/fixed" element={<Fixed />} />
          <Route path="/products/implants" element={<Implants />} />
          <Route path="/products/removable" element={<Removable />} />
          <Route path="/aboutus-mission" element={<AboutUsMission />} />
          <Route path="/aboutus-dentistry" element={<AboutUsDentistry />} />

          {/* Fixed Products Detail Routes */}
          <Route path="/products/fixed/bruxzir" element={<BruxZir />} />
          <Route path="/products/fixed/fullcast" element={<FullCast />} />
          <Route path="/products/fixed/zirconia" element={<Zirconia />} />
          <Route path="/products/fixed/pfm" element={<PFM />} />
          <Route path="/products/fixed/emax" element={<Emax />} />
          <Route path="/products/fixed/pmma" element={<PMMA />} />
          <Route path="/products/fixed/zirlux" element={<Zirlux />} />

          {/* Removable Products Detail Routes */}
          <Route path="/products/removable/castpartial" element={<CastPartial />} />
          <Route path="/products/removable/complete" element={<CompleteDenture />} />
          <Route path="/products/removable/economyacrylicpartial" element={<EconomyAcrylicPartial />} />
          <Route path="/products/removable/economydenture" element={<EconomyDenture />} />
          <Route path="/products/removable/valplastcastcombopartial" element={<ValplastCastComboPartial />} />
          <Route path="/products/removable/valplastflexiblepartial" element={<ValplastFlexiblePartial />} />

          {/* Implant Products Detail Routes */}
          <Route path="/products/implants/fczscrewretainedhybridcrown" element={<FCZScrewRetainedHybridCrown />} />
          <Route path="/products/implants/titaniumabutment" element={<TitaniumAbutment />} />
          <Route path="/products/implants/zirconiaabutment" element={<ZirconiaAbutment />} />
          <Route path="/products/implants/zirconiahybridimplantbridge" element={<ZirconiaHybridImplantBridge />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;